
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function ShowIcon(props) {
    const { style } = props;
    const classes = useStyles(props)()

    return(
        <svg className={classes.container}  style={style} width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.56711 0C10.339 0 12.019 0.614755 13.4817 1.75288C14.9444 2.8827 16.1897 4.53589 17.0841 6.60446C17.1509 6.7623 17.1509 6.94507 17.0841 7.0946C15.2954 11.2317 12.111 13.7074 8.56711 13.7074H8.55875C5.02325 13.7074 1.83879 11.2317 0.0501489 7.0946C-0.0167163 6.94507 -0.0167163 6.7623 0.0501489 6.60446C1.83879 2.46733 5.02325 0 8.55875 0H8.56711ZM8.56711 3.53069C6.71996 3.53069 5.22385 5.01773 5.22385 6.85369C5.22385 8.68134 6.71996 10.1684 8.56711 10.1684C10.4059 10.1684 11.902 8.68134 11.902 6.85369C11.902 5.01773 10.4059 3.53069 8.56711 3.53069ZM8.56811 4.77498C9.71318 4.77498 10.6493 5.70542 10.6493 6.85186C10.6493 7.98999 9.71318 8.92043 8.56811 8.92043C7.41469 8.92043 6.47857 7.98999 6.47857 6.85186C6.47857 6.71063 6.49529 6.57771 6.52036 6.44479H6.56215C7.48991 6.44479 8.24214 5.71373 8.27558 4.79991C8.36751 4.78329 8.46781 4.77498 8.56811 4.77498Z" fill="#2196C0"/>
        </svg>

    )
}


const useStyles = props => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: props.color,
            width: props.width,
         },
    }
}));